import "./TestCaseButton.css"

export default function TestCaseButton({setSelectedTest, testCaseID, selectedTest, passed}){
    return(
        <div className="test-case-button" 
            onClick={() => setSelectedTest(testCaseID)} 
            style={{
                border: selectedTest === testCaseID ? '1px solid rgba(43, 125, 233, 0.49)' : '1px solid  rgba(62, 62, 62, 0.51)',
                boxShadow: selectedTest === testCaseID ? '0 0 5px rgb(43, 125, 233)': 'none'
            }}
        >
           { passed == "Failed" && <span class="red dot"> </span>}
           { passed == "Accepted" && <span class="green dot"> </span>}
           <div style={{
                marginLeft: passed != "Await Submission" ? '10px' : '0px'
           }}> 
                Test {testCaseID+1} 
            </div> 
        </div>
    )

}
